import { ColumnType } from "antd/lib/table";
import Actions from "./components/Actions";
import { formatDateTime } from "ui/utils";
import Badge from "ui/components/badge";

export const columns: ColumnType<any>[] = [
  {
    title: "Nome",
    dataIndex: "nome",
    key: "nome",
    align: "center",
    render: (value: any) => <span>{value ?? "-"}</span>,
  },
  {
    title: "Próxima Execução",
    dataIndex: "dataProximaExecucao",
    key: "dataProximaExecucao",
    align: "center",
    render: (value: any) => <span>{value ? formatDateTime(value) : "-"}</span>,
  },
  {
    title: "Última Execução",
    dataIndex: "dataUltimaExecucao",
    key: "dataUltimaExecucao",
    align: "center",
    render: (value: any) => <span>{value ? formatDateTime(value) : "-"}</span>,
  },
  {
    title: "Último Registro Inserido",
    dataIndex: "dataUltimoRegistroInserido",
    key: "dataUltimoRegistroInserido",
    align: "center",
    render: (value: any) => <span>{value ? formatDateTime(value) : "-"}</span>,
  },
  {
    title: "Status",
    dataIndex: "ativo",
    key: "ativo",
    align: "center",
    render: (value: any) => (
      <Badge
        type={value ? "success" : "danger"}
        value={value ? "Ativo" : "Inativo"}
      />
    ),
  },
  {
    title: "Ações",
    dataIndex: "operacaoClasseId",
    align: "center",
    render: (value: string, record: any) => (
      <Actions id={record.recurringJobGroupId} />
    ),
  },
];
